import { IMAGES } from "@/lib/content";

export function MomentBand() {
  return (
    <section className="relative isolate overflow-hidden" data-testid="moment-band">
      <div className="absolute inset-0 -z-10">
        <img src={IMAGES.relayBW} alt="Leah Thames anchoring a relay" className="h-full w-full object-cover object-top" />
        <div className="absolute inset-0 bg-ink/55" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink/80 via-ink/30 to-transparent" />
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-40">
        <div className="max-w-2xl">
          <p className="label-eyebrow !text-blush">The Standard</p>
          <p className="mt-5 font-accent text-3xl sm:text-4xl md:text-5xl italic text-ivory leading-tight">
            "Every race starts long before I step onto the track."
          </p>
          <p className="mt-6 font-body text-sm md:text-base text-ivory/70 max-w-lg">Discipline in the dark hours. Grace under the lights. This is the work behind the results.</p>
        </div>
      </div>
    </section>
  );
}
